import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	teams: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.teams',
		defaultMessage: 'Teams',
		description: 'Label for Teams app shortcut button',
	},
	invitePeople: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.invite-people',
		defaultMessage: 'Invite people',
		description: 'Used in popup menu for user to invite new user',
	},
	createTeam: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.create-team',
		defaultMessage: 'Create a team',
		description: 'Used in popup menu for user to create a team',
	},
	createOrInvite: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-global-app-shortcuts.teams.create-or-invite',
		defaultMessage: 'Create or invite',
		description: 'Button to create a new team or invite new user',
	},
});
